/* eslint-disable react/jsx-props-no-spreading */

import MoreVertIcon from '@mui/icons-material/MoreVert';
import { SxProps, Theme } from '@mui/material';
import React from 'react';
import NavButton from '../MenuItemTypes/NavButton';
import MoreOptionsButtonModal from './MoreOptionsButtonModal';

const buttonSx = {
  width: 'fit-content',
};

export interface MenuItem {
  component: React.ReactNode;
}
interface MoreOptionsProps {
  buttonStyle?: SxProps<Theme>;
  navBarMenuItems: MenuItem[];
}
const MoreOptions: React.FC<React.PropsWithChildren<MoreOptionsProps>> = (props) => {
  const { navBarMenuItems, buttonStyle } = props;

  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  return (
    <>
      <NavButton
        icon={<MoreVertIcon data-testid="vertIcon" />}
        anchorRef={anchorRef}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        buttonStyle={[
          buttonSx,
          ...(Array.isArray(buttonStyle) ? buttonStyle : [buttonStyle]),
        ]}
      />

      <MoreOptionsButtonModal
        modalMenuItems={navBarMenuItems}
        anchorRef={anchorRef}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </>
  );
};

export default MoreOptions;
